<template>
  <div class="marketplaceDescriptionContainer">
    <div class="container">
      <img v-if="mobileImage && isMobile" :alt="title" class="w-100 contain mb-5" :src="mobileImage"/>
      <h4 class="text-center mb-sm-5 mb-3" :class="{'mt-4': !mobileImage && isMobile}">{{ title }}</h4>
      <div class="descriptionContentWrapper">
        <div class="descriptionBody" :class="{'col-sm-6 offset-sm-3 col-12 offset-0': !desktopImage && !isMobile}">
          <div v-for="(bodyHTML, index) in body" :key="`bodyhtml-${index}`" class="w-100" v-html="bodyHTML" />
        </div>
        <div v-if="desktopImage && !isMobile" class="imageWrapper">
          <img :alt="title" class="w-100 contain drop-shadow-2" :src="desktopImage"/>
        </div>
      </div>
      <div class="buttonControls flex-center mt-sm-5 mt-3">
        <a v-if="defaultButtonLink && defaultButtonText" class="btn btn-default " :href="defaultButtonLink" >
          {{ defaultButtonText }}
        </a>
        <a v-if="darkButtonLink && darkButtonText" class="btn btn-dark " :href="darkButtonLink" >
          {{ darkButtonText }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { baseIsMobile } from '../../marketplaces/mixins';

export default {
  name: 'MarketplaceDescription',
  mixins: [ baseIsMobile ],
  props: {
    body: {
      type: Array,
      required: true
    },
    darkButtonLink: {
      type: String,
      required: false,
    },
    darkButtonText: {
      type: String,
      required: false,
    },
    defaultButtonLink: {
      type: String,
      required: false,
    },
    defaultButtonText: {
      type: String,
      required: false,
    },
    desktopImage: {
      type: String,
      required: false
    },
    mobileImage: {
      type: String,
      required: false
    },
    title: {
      type: String,
      required: true
    },
  }
};
</script>

<style lang="scss">
@import '@sass/vue-imports.scss';
.marketplaceDescriptionContainer {
  padding: 100px 0;
  @include media-breakpoint-down(sm) {
    padding: 10px 0 25px;
  }

  .descriptionContentWrapper {
    display: flex;
    .descriptionBody {
      flex: 1 0 60%;
      padding-right: 40px;
      @include media-breakpoint-down(sm) {
        padding-right: 0;
      }
    }
    .imageWrapper {
      flex: 1 0 40%;
      padding-left: 40px;
      @include media-breakpoint-down(sm) {
        padding-left: 0;
      }

      img {
        object-position: center top;
      }
    }
  }

  .buttonControls {
    .btn {
      padding-left: 15px;
      padding-right: 15px;
    }
    .btn + .btn {
      margin-left: 20px;
    }
  }
}
</style>